import { render, staticRenderFns } from "./pcFooter.vue?vue&type=template&id=46531343&scoped=true&"
import script from "./pcFooter.vue?vue&type=script&lang=js&"
export * from "./pcFooter.vue?vue&type=script&lang=js&"
import style0 from "./pcFooter.vue?vue&type=style&index=0&id=46531343&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46531343",
  null
  
)

export default component.exports